import { ApolloClient, InMemoryCache } from "@apollo/client";
import axios from "axios";

const gqlErrorHandler = ({
  graphQLErrors,
  networkError,
  operation,
  response,
}) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) =>
      console.error(
        `ERROR onError graphQLErrors -> [GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );
  if (networkError) {
    console.error(
      `ERROR onError networkError -> [Network error]: ${networkError}`
    );
  }
  if (operation) {
    console.error(`ERROR onError operation -> `, operation);
  }
  if (response) {
    console.error(`ERROR onError response -> `, response);
  }
};

const cache = new InMemoryCache();

export const graphQLClient = new ApolloClient({
  cache: cache,
  uri:
    // This is the Main net
    // "https://api.thegraph.com/subgraphs/name/abdulsami39/phnxsubgraphmainnet",

    // New Mainnet subgraph by arun
    "https://api.thegraph.com/subgraphs/name/aroon4020/phnxdaov2",

  // This is the test net
  // "https://api.thegraph.com/subgraphs/name/danialansari/pheniox-subgraph-block",
  // old graph testnet danial ansari
  // "https://api.thegraph.com/subgraphs/name/danialansari/lpstaking-subgraph",
  // new graph testnet danial ansari
  // "https://api.thegraph.com/subgraphs/name/danialansari/pheniox-subgraph-block",
  // new graph testnet Arun 1
  // "https://api.thegraph.com/subgraphs/name/aroon4020/phnxdao2",
  // new Arun subgraph 2

  // "https://api.thegraph.com/subgraphs/name/aroon4020/phnxdaov2",
  // new Arun subgraph 3
  // "https://api.thegraph.com/subgraphs/name/aroon4020/phnxdaonew",

  onError: gqlErrorHandler,
});

export const baseUrl = `https://api.thegraph.com/subgraphs/name/aroon4020/phnxdaov2`;

export const getDashboardQuery = (address) => {
  return `{
  user(id: "${address.toLowerCase()}") {
    stake(first: 1000, where: { altQuantity_gt: 0 }
      orderBy: initiationTimestamp
      orderDirection: asc
      ) {
          id
          altQuantity
          initiationTimestamp
          durationTimestamp
        }
        history(first: 1000, orderBy: id, orderDirection: desc) {
          id
          altQuantity
          rewardAmount
          durationTimestamp
          initiationTimestamp
        }
      }
    }`;
};

// backup query
// export const getDashboardQuery = (address) => {
//   return `{
//   user(id: "${address.toLowerCase()}") {
//     stake(first: 1000, where: { altQuantity_gt: 0 }
//       orderBy: initiationTimestamp
//       orderDirection: asc
//       ) {
//         id
//         altQuantity
//         initiationTimestamp
//         durationTimestamp
//     }
//     history(first: 1000, orderBy: id, orderDirection: desc) {
//       id
//       altQuantity
//       rewardAmount
//       durationTimestamp
//       initiationTimestamp
//     }
//   }
// }`;
// };

export const GetDashboardData = async (address) => {
  // console.log("Coming hereeeeeeee");
  if (address) {
    // console.log("address at GetDashboardData", address);
    try {
      let response = await axios.post(baseUrl, {
        query: getDashboardQuery(address),
      });
      if (response) {
        response = response.data.data;

        if (response.user?.stake?.length < 1) {
          response.user.stake = [];
          return response;
        }
        if (response?.user) {
          var bb = response.user?.stake?.sort((a, b) => {
            let timestamp = Math.floor(+new Date() / 1000);

            let aa =
              Number(a.initiationTimestamp) +
              Number(a.durationTimestamp) -
              timestamp;
            let bb =
              Number(b.initiationTimestamp) +
              Number(b.durationTimestamp) -
              timestamp;

            return aa - bb;
          });

          response.user.stake = bb;

          return response;
        }
      }
    } catch (e) {
      console.error("Err in fetching dashboard data!!!!", e);
    }
  }
};

export const getStakeQuery = (address) => {
  return `{
  user(id: "${address.toLowerCase()}") {
    stake(
      where: { altQuantity_gt: 0 }
      orderBy: initiationTimestamp
      orderDirection: asc
    ) {
      id
      altQuantity
      initiationTimestamp
      durationTimestamp
    }
  }
}`;
};

export const GetUnstakeData = async (address) => {
  try {
    let response = await axios.post(baseUrl, {
      query: getDashboardQuery(address),
    });
    // console.log("address Response unstake", response.data.data);
    return response.data.data;
  } catch (e) {
    console.error("Err in fetching unstake data!!!!", e);
  }
};
